const elementTypes = Object.freeze([
	{
		"type": "numericPrediction",
		"icon": "123",
		"text": "Prediction",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "registrationForm",
		"icon": "how_to_reg",
		"text": "Registration",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"(){
			return getNonDecorativeElements().map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": true,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "imageChoice",
		"icon": "collections",
		"text": "Image Choice",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "mvp",
		"icon": "sports_gymnastics",
		"text": "MVP",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "soccerLineupSelector",
		"icon": "sports_soccer",
		"text": "Line-Up Selector",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "poll",
		"icon": "how_to_vote",
		"text": "Poll",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "multipleChoice",
		"icon": "quiz",
		"text": "Multiple Choice",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.isInput && this.type!==e.type).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": true,
		"isQuizInputElement": true,
		"isTimerElement": false,
	},
	{
		"type": "quizResults",
		"icon": "checklist",
		"text": "Quiz Results",
		"allowedPageTypes": ["normal", "endPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": ["multipleChoice"],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": true,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "wheelOfPrizes",
		"icon": "interests",
		"text": "Wheel Of Prizes",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": true,
		get "conflictingElementTypes"(){
			return getNonDecorativeElements().map(e=>e.type);
		},
		"hasWizard": true,
		"extraPagesBefore": ["registrationForm", "wheelOfPrizesPreview"],
		"unique": true,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "wheelOfPrizesPreview",
		"icon": "interests",
		"text": "Wheel Of Prizes (Fake Spin)",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"(){
			return getNonDecorativeElements().map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": true,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "scratch",
		"icon": "casino",
		"text": "Scratch To Win",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": true,
		get "conflictingElementTypes"(){
			return getNonDecorativeElements().map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "submitButton",
		"icon": "ads_click",
		"text": "Submit",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"() {
			return elementTypes.filter(e=>e.submitsPage).map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "image",
		"icon": "image",
		"text": "Image",
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": [],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "spacer",
		"icon": "expand",
		"text": "Spacer",
		"conflictingElementTypes": [],
		"hasWizard": false,
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "link",
		"icon": "link",
		"text": "Link",
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": [],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "iframe",
		"icon": "filter_frames",
		"text": "IFrame",
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": [],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "text",
		"icon": "html",
		"text": "Text",
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": [],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "slideShow",
		"icon": "web_stories",
		"text": "Slide Show",
		"allowedPageTypes": ["normal", "endPage", "expiredPage"],
		"allowedOnLocked": true,
		"conflictingElementTypes": [],
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": true,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "ugc",
		"icon": "web_stories",
		"text": "User Generated Content (Beta)",
		"allowedPageTypes": ["endPage"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"(){
			return getNonDecorativeElements().map(e=>e.type);
		},
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": true,
		"isDecorative": false,
		"submitsPage": true,
		"isInput": true,
		"isQuizInputElement": false,
		"isTimerElement": false,
	},
	{
		"type": "timer",
		"icon": "timer",
		"text": "Countdown Timer",
		"allowedPageTypes": ["normal"],
		"allowedOnLocked": false,
		get "conflictingElementTypes"(){
			return elementTypes.filter(e=>e.isTimerElement || (e.isInput && !e.isQuizInputElement)).map(e=>e.type);
		},
		//TBI: show timer only when multiplechoice exists, also delete timer when deleting the last multiplechoice
		"hasWizard": false,
		"extraPagesBefore": [],
		"unique": false,
		"isDecorative": false,
		"submitsPage": false,
		"isInput": false,
		"isQuizInputElement": false,
		"isTimerElement": true,
		"customConflictCheck": (action, actionElementType, preActionPageElements) =>{
			let hasConflict = false;
			let message = null;
			let quizElementCount = 0;
			let timerElementCount = 0;

			preActionPageElements.forEach(e=>{
				if(elementTypeMap.get(e.type)?.isQuizInputElement) quizElementCount++;
				if(elementTypeMap.get(e.type)?.isTimerElement) timerElementCount++;
			});
			if(action==="ADD"){
				if(actionElementType?.isQuizInputElement) quizElementCount++;
				if(actionElementType?.isTimerElement) timerElementCount++;
			} else if(action==="REMOVE") {
				if(actionElementType?.isQuizInputElement) quizElementCount--;
				if(actionElementType?.isTimerElement) timerElementCount--;
			}

			if(timerElementCount>0 && quizElementCount!==1){
				hasConflict = true;
				message = "A page with a timer must contain exactly one multiple-choice question.";
				if(actionElementType){
					if(quizElementCount===0) {
						if(action==="ADD"){
							if(actionElementType.isTimerElement) message = "Add a multiple-choice question before adding a timer.";
						}
						else if(action==="REMOVE"){
							if(actionElementType.isQuizInputElement) message = "Remove the timer before removing the only multiple-choice question.";
						}
					} else {
						if(action==="ADD"){
							if(actionElementType.isTimerElement) message = "A timer can only be added to a page with exactly one multiple-choice question.";
							if(actionElementType.isQuizInputElement) message = "A timed page can only have one multiple-choice question.";
						}
					}
				}
			}
			return {hasConflict, message};
		},
	},
]);
export const elementTypeMap = new Map(elementTypes.map((t)=>[t.type, t]));
const simpleDecorativeElementTypes = Object.freeze(elementTypes.filter((e)=>e.isDecorative&&!e.unique&&!e.conflictingElementTypes.length).map((e)=>e.type));
const nonDecorativeElementTypes = Object.freeze(elementTypes.filter((e)=>!e.isDecorative).map((e)=>e.type));
const campaignTypes = [
	{
		"type": "numericPrediction",
		"icon": "123",
		"text": "Prediction",
		"allowedElementTypes": ["numericPrediction", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "registrationForm",
		"icon": "how_to_reg",
		"text": "Registration",
		"allowedElementTypes": ["registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "imageChoice",
		"icon": "collections",
		"text": "Image Choice",
		"allowedElementTypes": ["imageChoice", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "mvp",
		"icon": "sports_gymnastics",
		"text": "MVP",
		"allowedElementTypes": ["mvp", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "soccerLineupSelector",
		"icon": "sports_soccer",
		"text": "Line-Up Selector",
		"allowedElementTypes": ["soccerLineupSelector", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "poll",
		"icon": "how_to_vote",
		"text": "Poll",
		"allowedElementTypes": ["poll", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "wheelOfPrizes",
		"icon": "interests",
		"text": "Wheel Of Prizes",
		"allowedElementTypes": ["wheelOfPrizes", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "scratch",
		"icon": "casino",
		"text": "Scratch To Win",
		"allowedElementTypes": ["scratch", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "quiz",
		"icon": "quiz",
		"text": "Quiz",
		"allowedElementTypes": ["multipleChoice", "registrationForm", "quizResults", "submitButton", "timer", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "wheelOfPrizesPreview",
		"icon": "interests",
		"text": "Wheel Of Prizes (Fake Spin)",
		"allowedElementTypes": ["wheelOfPrizes", "registrationForm", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": ["registrationForm", "wheelOfPrizes", "wheelOfPrizesPreview"],
		"nonDeletablePages": ["registrationForm", "wheelOfPrizes", "wheelOfPrizesPreview"],
	},
	{
		"type": "ugc",
		"icon": "web_stories",
		"text": "User Generated Content (Beta)",
		"allowedElementTypes": ["ugc", "submitButton", ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
	{
		"type": "custom",
		"icon": "interests",
		"text": "Custom Type",
		"allowedElementTypes": [...nonDecorativeElementTypes, ...simpleDecorativeElementTypes],
		"nonDraggablePages": [],
		"nonDeletablePages": [],
	},
];
export const campaignTypeMap = new Map(campaignTypes.map((t)=>[t.type, t]));

export const getPageElements = (type = null) => {
	if (type) {
		return elementTypes.find((el) => el.type === type);
	}
	return elementTypes;
};

export function getCampaignAllowedElements(campaignType) {
	const out = [];
	const ct = campaignTypeMap.get(campaignType);
	if (ct) {
		ct.allowedElementTypes.forEach((type)=>{
			if (elementTypeMap.has(type)) out.push(elementTypeMap.get(type));
		});
	}
	return out;
}
export function getCampaignTypes() {
	return campaignTypes;
}
function getNonDecorativeElements(){
	return elementTypes.filter(e=>!e.isDecorative);
}
